<template>
  <Form
    ref="dataDetails"
    :model="dataDetails"
    :label-width="140"
    :disabled="!show"
    :rules="ruleFrom"
  >
    <Card style="margin-bottom: 10px">
      <span slot="title">
        {{ $t("Transport info") }}
      </span>
      <Row :gutter="10" style="padding-top: 10px; margin: -16px">
        <Col span="6">
          <FormItem :label="$t('dingcangCompany')">
            <Select
              v-model="dataDetails.dingcang_company"
              filterable
              filter-by-label
              :placeholder="$t('select') + $t('dingcangCompany')"
            >
              <Option
                class="company-class"
                v-for="item in otherObj.ding"
                :value="item.id"
                :key="item.id"
                >{{ item.code }} - {{ item.alias }}</Option
              >
            </Select>
          </FormItem>
        </Col>

        <Col span="6">
          <FormItem :label="$t('method_name')">
            <Input v-model="dataDetails.shipment.transport_code_txt" disabled>
            </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('company')">
            <Input v-model="dataDetails.shipment.consignee" disabled> </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('allow_depart')">
            <Input v-model="dataDetails.shipment.from_country" disabled>
            </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('allow_arrive')">
            <Input v-model="dataDetails.shipment.to_country" disabled> </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('city_name')">
            <Input v-model="dataDetails.shipment.city_name" disabled> </Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('detailedAddress')">
            <Input
              type="textarea"
              v-model="dataDetails.shipment.consignee_address"
              disabled
              :autosize="{ minRows: 2, maxRows: 2 }"
            >
            </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('is_solely')">
            <RadioGroup v-model="dataDetails.is_solely">
              <Radio label="YES" border disabled>{{ $t("YES") }}</Radio>
              <Radio label="NO" border disabled>{{ $t("NO") }}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col v-if="dataDetails.is_solely === 'YES'" span="6">
          <FormItem :label="$t('documents')">
            <Input
              disabled
              v-model="dataDetails.documents"
              placeholder="Please Enter dan_zheng_nums"
            >
            </Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('warehouseName')" prop="cangku">
            <Input v-model="dataDetails.shipment.warehouse" disabled></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODCurrency')">
            <Select
              v-model="dataDetails.cod_currency"
              :placeholder="$t('CODCurrency')"
            >
              <Option
                v-for="item in currencyList"
                :value="item.code"
                :key="item.code"
                :label="item.title + '(' + item.code + ')'"
              ></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODAmount')">
            <InputNumber
              v-model="dataDetails.cod_amount"
              v-bind="{
                step: 0.01,
                min: 0,
                style: 'width:100%',
              }"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('CODFee')">
            <InputNumber
              v-model="dataDetails.cod_handlefee"
              v-bind="{
                step: 0.01,
                min: 0,
                style: 'width:100%',
              }"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="6" v-if="!salesmanFlag">
          <FormItem :label="$t('distribution_agent')">
            <Select
              v-model="dataDetails.delivery_agent_id"
              :placeholder="$t('select') + $t('agentT')"
              filterable
              filter-by-label
              clearable
            >
              <Option
                v-for="item in agentList"
                :value="item.id"
                :key="item.id"
                :label="item.agent_name"
              ></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6" v-if="!salesmanFlag">
          <FormItem :label="$t('order_refCode')">
            <Input
              v-model="dataDetails.agent_number"
              style="width: 100%"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="大包类型">
            <Input
              v-model="dataDetails.package_size"
              :readonly="true"
              style="width: 100%"
            ></Input>
          </FormItem>
        </Col>
      </Row>
    </Card>
    <div class="table-header">
      {{ $t("Goods Info") }}
    </div>
    <Table
      height="200"
      :data="dataDetails.goods"
      :columns="tableTitle"
      border
      stripe
      style="margin-bottom: 10px"
    >
      <template
        v-for="item in tableTitle"
        :slot="item.slot"
        slot-scope="{ row, index }"
      >
        <template v-if="item.components == 'btn'">
          <FormItem :label-width="0" :key="item.slot" style="margin-top: 10px">
            <template v-if="index == 0">
              <Button
                type="primary"
                @click="addClick(row)"
                style="margin-right: 5px"
                size="small"
              >
                <Icon type="md-add"></Icon>
              </Button>
            </template>
            <Button
              type="error"
              @click="delClick(index)"
              size="small"
              :disabled="dataDetails.goods.length == 1"
            >
              <Icon type="ios-trash"></Icon>
            </Button>
          </FormItem>
        </template>
        <FormItem
          :label-width="0"
          :key="item.slot"
          :prop="'goods.' + index + '.' + item.slot"
          :rules="item.rules"
          v-else
          style="margin-top: 10px"
        >
          <RadioGroup
            v-model="dataDetails.goods[index][item.slot]"
            v-if="item.components == 'Radio'"
          >
            <Radio :label="1">{{ $t("YES") }}</Radio>
            <Radio :label="0">{{ $t("NO") }}</Radio>
          </RadioGroup>
          <Select
            v-model="dataDetails.goods[index][item.slot]"
            v-else-if="item.components == 'Select'"
            :transfer="true"
            style="text-align: left"
            filterable
            filter-by-label
            :placeholder="item.title"
            clearable
            :multiple="item.multiple"
          >
            <template v-if="item.slot == 'cate_id'">
              <Option
                :value="item.id"
                :key="item.id"
                v-for="item in cateList"
                :label="item.name"
                @click.native="
                  dataDetails.goods[index]['goods_name'] = item.name
                "
              >
              </Option>
            </template>
            <template v-else>
              <Option
                :value="item.name"
                :key="item.name"
                v-for="item in otherObj.add_service"
                :label="item.name"
              >
              </Option>
            </template>
          </Select>
          <component
            :is="item.components"
            :prop="'goods.' + index + '.' + item.slot"
            v-model="dataDetails.goods[index][item.slot]"
            v-bind="item.bind"
            v-else
            :disabled=" item.dissbled "
            @on-blur="inputBlur(index, item.slot)"
          >
          </component>
        </FormItem>
      </template>
    </Table>
    <Card style="margin-bottom: 10px">
      <span slot="title">
        {{ $t("Other Info") }}
      </span>
      <Row :gutter="10" style="padding-top: 10px; margin: -16px">
        <Col span="6">
          <FormItem :label="$t('baoguan')">
            <Select
              v-model="dataDetails.baoguan_type"
              filterable
              :placeholder="$t('select') + $t('baoguan')"
            >
              <Option
                class="company-class"
                v-for="item in otherObj.baoguan_type"
                :value="item.id"
                :key="item.id"
                :label="item.name"
              ></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('documents')">
            <Input v-model="dataDetails.dan_zheng_nums"> </Input>
          </FormItem>
        </Col>
<!--        <Col span="6">-->
<!--          <FormItem :label="$t('next_page')">-->
<!--            <Input v-model="dataDetails.xu_page"> </Input>-->
<!--          </FormItem>-->
<!--        </Col>-->
        <Col span="6">
          <FormItem :label="$t('safetyService')">
            <RadioGroup v-model="dataDetails.is_safe">
              <Radio :label="1"  :disabled="!showSafePlan">{{ $t("YES") }}</Radio>
              <Radio :label="0"  :disabled="!showSafePlan">{{ $t("NO") }}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('保险方案')">
              <RadioGroup @on-change="uploadSafePlan" v-if="dataDetails.is_safe === 1" v-model="dataDetails.safe_plan">
              <Radio v-for="(kv, vv) in safePlanArray" :label="kv.index" :key="'SP_' + vv">{{ kv.name }}</Radio>
                <Radio v-if="dataDetails.shipment.transport_code_txt === '快运'" :label="8">快运保险</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('DeclaredValue')">
            <Input v-model="dataDetails.values">
              <Select v-model="dataDetails.value_currency" slot="append" style="width: 70px">
                <Option value="USD">美元</Option>
                <Option value="CNY">人民币</Option>
              </Select>
            </Input>
          </FormItem>
        </Col>
      </Row>
    </Card>
    <div class="table-header">
      {{ $t("valueServiceInfo") }}
    </div>
    <Table
      height="150"
      ref="selection"
      :data="serverList"
      :columns="valueServer"
      border
      stripe
      style="margin-bottom: 10px"
    >
    </Table>
    <div class="footer-btn" v-if="show">
      <Button type="text" @click="close">{{ $t("cancel") }}</Button>
      <Button v-if="hasPermission(196) && waitConfirm(row.confirmed_time)" type="primary" @click="save">
        {{ $t("save") }}
      </Button>
      <Button
        v-if="hasPermission(493)"
        :type="row.confirmed_time > 0 ? 'warning' : 'primary'"
        @click="submitOk"
        >{{
          row.confirmed_time > 0
            ? $t("cancel") + $t("confirm")
            : $t("confirm") + $t("order_submit")
        }}</Button
      >
    </div>
  </Form>
</template>
<script>
import {
  getContacts,
  getDoubleInfo,
  saveDoubleInfo,
  confirmDoubleInfo,
  getServiceDetail, getSafePlanValues,
} from "@/api/double/list";
import { getCountryCategory } from "@/api/storage/category";
import { getCurrency } from "@/api/finance/cod_rate";
import { getAgent } from "@/api/tracker/agent";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    'dataDetails.values'(newValue, oldValue) {
      let values = parseFloat(newValue);

      this.dataDetails.is_safe = values > 0 ? 1 : 0
      this.showSafePlan = values > 0
      if (this.showSafePlan === false) {
        this.dataDetails.safe_values = 0
        this.dataDetails.safe_plan = 0
      } else {
        this.dataDetails.safe_values = (this.safePlanValues[this.dataDetails.safe_plan] * parseFloat(this.dataDetails.values)).toFixed(2);
      }
    },
  },
  computed: {
    valueServer() {
      let columns = [];
      columns.push({
        title: this.$t("valueService") + this.$t("alipay_name"),
        align: "center",
        tooltip: true,
        key: "service_name",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("Billing") + this.$t("noofpieces"),
        align: "center",
        tooltip: true,
        key: "quantity",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("valueService") + this.$t("cost_t"),
        align: "center",
        tooltip: true,
        key: "total_amount",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("operate"),
        align: "center",
        tooltip: true,
        key: "create_name",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("operation") + this.$t("time"),
        align: "center",
        tooltip: true,
        key: "create_time",
        minWidth: 120,
      });
      return columns;
    },
    tableTitle() {
      let columns = [
        {
          title: this.$t("category"),
          align: "center",
          slot: "cate_id",
          width: 150,
          components: "Select",
          rules: [
            {
              required: true,
              message: this.$t("select") + this.$t("category"),
              type: "number",
              trigger: "change",
            },
          ],
        },
        {
          title: this.$t("Carton No."),
          slot: "box_number_remarks",
          align: "center",
          tooltip: true,
          width: 95,
          components: "Input",
        },
        {
          slot: "pieces_num",
          align: "center",
          tooltip: true,
          minWidth: 85,
          dissbled: true,
          components: "InputNumber",
          renderHeader: (h) => {
            var text = this.$t("CTNS") + "<br/>(CTNS)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
          rules: [
            {
              required: true,
              message: this.$t("enter") + this.$t("CTNS"),
              type: "number",
              trigger: "blur",
            },
          ],
          bind: {
            style: "width:100%",
            min: 0,
            step: 1,
          },
        },
        {
          slot: "weight",
          align: "center",
          tooltip: true,
          width: 80,
          components: "InputNumber",
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.0001,
          },
          dissbled: true,
          rules: [
            {
              required: true,
              message: this.$t("doubleweight") + this.$t("doubleweight"),
              type: "number",
              trigger: "blur",
            },
          ],
          renderHeader: (h) => {
            var text = this.$t("doubleweight") + "<br/>(KG)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
        },
        {
          slot: "volume",
          align: "center",
          width: 80,
          tooltip: true,
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.0001,
          },
          dissbled: true,
          components: "InputNumber",
          rules: [
            {
              required: true,
              message: this.$t("skuVolume") + this.$t("skuVolume"),
              type: "number",
              trigger: "blur",
            },
          ],
          renderHeader: (h) => {
            var text = this.$t("skuVolume") + "<br/>(CBM)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
        },
        {
          slot: "charging_weight",
          align: "center",
          tooltip: true,
          width: 80,
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.0001,
          },
          dissbled: true,
          components: "InputNumber",
          rules: [
            {
              required: true,
              message: this.$t("enter") + this.$t("charge_params"),
              type: "number",
              trigger: "blur",
            },
          ],
          renderHeader: (h) => {
            var text = this.$t("charge_params") + "<br/>(KG)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
        },
        {
          slot: "charging_volume",
          align: "center",
          tooltip: true,
          width: 80,
          dissbled: true,
          components: "InputNumber",
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.0001,
          },
          rules: [
            {
              required: true,
              message: this.$t("enter") + this.$t("charging_volume"),
              type: "number",
              trigger: "blur",
            },
          ],
          renderHeader: (h) => {
            var text = this.$t("charging_volume") + "<br/>(CBM)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
        },
        {
          slot: "volume_weight",
          align: "center",
          tooltip: true,
          width: 80,
          dissbled: true,
          components: "InputNumber",
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.0001,
          },
          rules: [
            {
              required: true,
              message: this.$t("enter") + this.$t("charge_volume"),
              type: "number",
              trigger: "blur",
            },
          ],
          renderHeader: (h) => {
            var text = this.$t("charge_volume") + "<br/>(KG)";
            return h("span", {
              domProps: {
                innerHTML: text,
              },
            });
          },
        },
        {
          title: this.$t("battery"),
          slot: "charged",
          align: "center",
          width: 130,
          components: "Radio",
        },
        {
          title: this.$t("valueService"),
          slot: "add_services",
          align: "center",
          width: 120,
          multiple: true,
          components: "Select",
        },
        {
          title: this.$t("quantity_num"),
          slot: "nums",
          align: "center",
          components: "Input",
          bind: {
            style: "width:100%",
          },
          minWidth: 80,
          // rules: [
          //   {
          //     required: true,
          //     message: this.$t("enter") + this.$t("quantity_num"),
          //     trigger: "blur"
          //   }
          // ]
        },
        {
          title: this.$t("Other Remark"),
          slot: "remarks",
          align: "center",
          bind: {
            type: "textarea",
            rows: 2,
          },
          components: "Input",
          width: 100,
        },
        {
          title: this.$t("operate"),
          key: "create_name",
          align: "center",
          width: 80,
          tooltip: true,
        },
        {
          title: this.$t("operation") + this.$t("time"),
          key: "create_time",
          align: "center",
          width: 150,
        },
        {
          title: this.$t("operation"),
          slot: "operation",
          align: "center",
          width: 100,
          components: "btn",
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      showSafePlan: false,
      enablePlanSelect: false,
      serverList: [],
      agentList: [],
      currencyList: [],
      cateList: [],
      otherObj: {},
      safePlanValues: {},
      safePlanArray: [],
      dataDetails: {
        dingcang_company: "",
        baoguan_type: "",
        xu_page: 0,
        dan_zheng_nums: "",
        is_safe: "",
        remarks: "",
        values: "",
        value_currency: "USD",
        shipment: {
          transport_code_txt: "",
          consignee: "",
          from_country: "",
          to_country: "",
        },
      },
      preForm: {},
      ruleFrom: {},
      salesmanFlag: [37, 38].includes(this.$store.state.user.info.role_id)
    };
  },
  mounted() {
    getServiceDetail(this.row.airway_number).then((res) => {
      this.serverList = res.data.payload;
    });
    getAgent().then((res) => {
      this.agentList = res.data.payload.rows;
    });
    getContacts().then((res) => {
      this.otherObj = res.data.payload;
    });
    getCurrency().then((res) => {
      this.currencyList = res.data.payload;
    });
    getSafePlanValues(this.row.airway_number).then((res) => {
      this.safePlanValues = res.data.payload.values;
      this.safePlanArray = res.data.payload.plans;

      getDoubleInfo(this.row.airway_number).then((res) => {
        if (res.data.status) {
          this.dataDetails = res.data.payload;
          console.log(this.dataDetails.safe_plan, this.safePlanArray);
          if (this.show) {
            this.dataDetails.goods.length == 0 &&
            this.dataDetails.goods.push({
              cate_id: "",
              box_number_remarks: "",
              pieces_num: 0,
              weight: 0,
              volume: 0,
              charging_volume: 0,
              charging_weight: 0,
              volume_weight: 0,
              charged: 0,
              add_services: [],
              nums: 0,
              remarks: "",
            });
          }
          this.preForm = JSON.parse(JSON.stringify(this.dataDetails));
        }
        getCountryCategory({
          country: this.dataDetails.shipment.to_country,
          flight: this.dataDetails.shipment.from_country,
          transport: this.dataDetails.shipment.transport_code,
        }).then((res) => {
          this.cateList = res.data.payload;
        });
        this.$forceUpdate()
      });
    })

  },
  methods: {
    uploadSafePlan(newValue) {
      console.log(newValue)
      this.dataDetails.safe_values = (this.safePlanValues[newValue] * parseFloat(this.dataDetails.values)).toFixed(2);
    },
    confirmSafeCondition(newValue) {
      let values = parseFloat(this.dataDetails.values) > 0
      if (!values && newValue === 1) {
        this.$Message.error('申报价值低于0.01无法选择保险服务')
        this.dataDetails.is_safe = 0
        this.$forceUpdate()
        console.log(this.dataDetails.is_safe)
      }
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    enablePlan(v) {
      this.enablePlanSelect = v
      console.log(v)
    },
    waitConfirm(confirmTime) {
      console.log(confirmTime)
      return parseInt(confirmTime) === 0
    },
    submitOk() {
      if (this.dataDetails.is_safe && !this.dataDetails.safe_plan) {
        this.$Message.error("选择了投保必须选择保险方案")
        return
      }

      this.dataDetails.safe_values = (this.safePlanValues[this.dataDetails.safe_plan] * parseFloat(this.dataDetails.values)).toFixed(2);

      this.$Spin.show()
      let data = {
        type: this.row.confirmed_time > 0 ? "NO" : "YES",
        ...this.dataDetails,
      };



      confirmDoubleInfo(this.row.airway_number, data).then((res) => {
        this.$Spin.hide()
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
        });
        if (res.data.status) {
          this.close();
          this.$page.getList();
        }
      }).catch(e => this.$Spin.hide());
    },
    save() {
      this.$refs["dataDetails"].validate((valid) => {
        // console.log(this.dataDetails.delivery_agent_id,this.agentList);
        // if (this.dataDetails.delivery_agent_id)
        //   this.dataDetails.delivery_agent_id = this.agentList.find(
        //     t => t.id === this.dataDetails.delivery_agent_id
        //   ).agent_name;
        if (valid) {
          if (this.dataDetails.is_safe && !this.dataDetails.safe_plan) {
            this.$Message.error("选择了投保必须选择保险方案")
            return
          }
          saveDoubleInfo(this.row.airway_number, this.dataDetails).then(
            (res) => {
              this.$Message[res.data.status ? "success" : "error"]({
                background: true,
                content: res.data.msg,
              });
              // if (res.data.status) {
              //   this.close();
              //   this.$page.getList();
              // }
            }
          );
        } else {
          console.log("error");
        }
      });
    },
    inputBlur(num, text) {
      if (
        this.dataDetails.shipment.transport_code_txt == "空运" &&
        text == "volume_weight"
      ) {
        this.dataDetails.goods[num].charging_volume = parseFloat(
          (Number(this.dataDetails.goods[num].volume_weight) / 167).toFixed(4)
        );
      }
    },
    addClick() {
      this.dataDetails.goods.push({
        cate_id: "",
        box_number_remarks: "",
        pieces_num: 0,
        weight: 0,
        volume: 0,
        charging_volume: 0,
        charging_weight: 0,
        volume_weight: 0,
        charged: 0,
        add_services: [],
        nums: 0,
        remarks: "",
      });
    },
    delClick(index) {
      this.dataDetails.goods.splice(index, 1);
    },
    // // 是否单独报关
    // solelyChange(val) {
    //   console.log("val", val);
    //   switch (val) {
    //     case "YES":
    //       this.dataDetails.baoguan_type = 9;
    //       break;
    //     default:
    //       this.dataDetails.baoguan_type = 8;
    //       break;
    //   }
    // },
    // // 单证套数
    // documentChange() {
    //   if (this.dataDetails.is_solely == "YES") {
    //     this.dataDetails.dan_zheng_nums = this.dataDetails.documents;
    //   }
    //   // console.log("val", this.dataDetails.documents);
    // }
  },
};
</script>

<style lang="less" scoped>
.table-header {
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding: 14px 16px;
  line-height: 1;
}
.from-div .ivu-select-dropdown {
  width: 100% !important;
}
.ivu-select-item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.unit-class {
  border-left: 1px solid #e8eaec;
  padding: 0 10px;
}
.double-weight {
  border: 1px solid #e8eaec;
  display: flex;
  border-radius: 6px;
}
.footer-btn {
  width: 100%;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.footer-btn button {
  margin-left: 10px;
}
/deep/ .ivu-table-cell {
  padding: 0 5px !important;
}
</style>
